import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContainerView } from './container_view';
function normalizeLinks(html) {
    return html.replace(/<a\b([^>]*?)\bhref\s*=\s*(['"])(.*?)\2([^>]*)>/gi, (match, pre, quote, href, post) => {
        const needsProtocol = !/^https?:\/\//i.test(href);
        const nextHref = needsProtocol ? `https://${href}` : href;
        const attrs = `${pre}href=${quote}${nextHref}${quote}${post}`;
        const hasTarget = /\btarget\s*=/.test(attrs);
        const hasRel = /\brel\s*=/.test(attrs);
        return `<a${attrs}${hasTarget ? '' : ' target="_blank"'}${hasRel ? '' : ' rel="noopener noreferrer"'}>`;
    });
}
export const ResourcesPreview = ({ messages, sortIndex }) => {
    if (!messages) {
        return null;
    }
    return [
        _jsxs(ContainerView, { children: [_jsx("style", { children: `
          .resources-preview a{
            color: revert; 
            text-decoration: revert;
          }
        ` }), _jsx("div", { style: { padding: '2rem', wordBreak: 'break-word' }, className: 'resources-preview', children: Object.keys(messages)
                        .sort((a, b) => { var _a, _b; return ((_a = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[a]) !== null && _a !== void 0 ? _a : 0) - ((_b = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[b]) !== null && _b !== void 0 ? _b : 0); })
                        .map((message) => (_jsx("div", { dangerouslySetInnerHTML: { __html: normalizeLinks(messages[message]) } }, message))) })] }, 'resources-preview-root'),
    ];
};
//# sourceMappingURL=resources.preview.component.js.map